import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginModalService {
  private readonly _open$ = new Subject<void>();
  public readonly open$: Observable<void> = this._open$.asObservable();

  open(): void {
    this._open$.next();
  }
}
